import { cn } from '@/lib/utils'
import React, { useEffect } from 'react'
import type { ButtonProps } from '../_ui/Button'
import { Button } from '../_ui/Button'

const AddToCartButton = (props: ButtonProps) => {
  const [isAddedToCart, setIsAddedToCart] = React.useState(false)

  useEffect(() => {
    if (isAddedToCart) {
      setTimeout(() => {
        setIsAddedToCart(false)
      }, 3000)
    }
  }, [isAddedToCart])

  return (
    <Button
      {...props}
      onClick={(event) => {
        setIsAddedToCart(true)

        props.onClick?.(event)
      }}
      className={cn(
        'mt-5 w-full rounded-full bg-secondary text-white',
        props.className,
      )}
      variant="secondary"
      size={props.size ?? 'lg'}
    >
      {isAddedToCart ? 'Added to your cart!' : props.children}
    </Button>
  )
}

export default AddToCartButton
